var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: _vm.compact ? 'pl-3 border-left border-secondary' : ''
  }, [_c('div', {
    staticClass: "d-flex justify-content-start mb-2"
  }, [_vm.customer.merchant_type_name ? _c('b-badge', {
    style: "font-size: ".concat(_vm.compact ? '0.85rem' : '0.9rem', ";"),
    attrs: {
      "pill": "",
      "variant": "primary"
    }
  }, [_vm._v(" " + _vm._s(_vm.customer.merchant_type_name.type_name) + " ")]) : _vm._e()], 1), _c('div', {
    staticClass: "d-flex align-items-center mb-2"
  }, [_c('i', {
    class: "mdi mdi-account mr-2 ".concat(_vm.compact ? 'text-muted' : '')
  }), _c('strong', {
    staticClass: "mr-2 info-label"
  }, [_vm._v("姓名：")]), _c('span', [_vm._v(_vm._s(_vm.customer.name))])]), _c('div', {
    staticClass: "d-flex align-items-center mb-2"
  }, [_c('i', {
    class: "mdi mdi-account-card-details mr-2 ".concat(_vm.compact ? 'text-muted' : '')
  }), _c('strong', {
    staticClass: "mr-2 info-label"
  }, [_vm._v("識別編號：")]), _c('span', [_vm._v(_vm._s(_vm.customer.outer_code || '-'))])]), _c('div', {
    staticClass: "d-flex align-items-center mb-2"
  }, [_c('i', {
    class: "mdi mdi-cellphone mr-2 ".concat(_vm.compact ? 'text-muted' : '')
  }), _c('strong', {
    staticClass: "mr-2 info-label"
  }, [_vm._v("手機：")]), _c('span', [_vm._v(" " + _vm._s(_vm.customer.mobile_phone || '-') + " "), _vm.customer.phone_verified_at ? _c('span', {
    staticClass: "mdi mdi-verified ml-1",
    staticStyle: {
      "color": "#009100"
    }
  }) : _vm._e()])]), _c('div', {
    staticClass: "d-flex align-items-center mb-2"
  }, [_c('i', {
    class: "mdi mdi-account-check mr-2 ".concat(_vm.compact ? 'text-muted' : '')
  }), _c('strong', {
    staticClass: "mr-2 info-label"
  }, [_vm._v("註冊時間：")]), _c('span', [_vm._v(" " + _vm._s(_vm.customer.registered_at ? _vm.formatDate(_vm.customer.registered_at) : '-') + " "), _vm.customer.registered_at ? _c('span', {
    staticClass: "mdi mdi-verified ml-1",
    staticStyle: {
      "color": "#009100"
    }
  }) : _vm._e()])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }